export const numberFilterOperations = ['equal', 'notEqual', 'greaterThan', 'greaterThanOrEqual', 'lessThan', 'lessThanOrEqual'];
export const greaterOrEqualLessOrEqualOperations = ['greaterThanOrEqual', 'lessThanOrEqual'];
export const availableFilterOperations = [
  'contains',
  'notContains',
  'startsWith',
  'endsWith',
  'equal',
  'notEqual',
  'greaterThan',
  'greaterThanOrEqual',
  'lessThan',
  'lessThanOrEqual'
];

export const getFilterOperationCamelCase = filterOpString => {
  return [...availableFilterOperations, ...numberFilterOperations].find(op => op?.toLowerCase() === filterOpString?.toLowerCase());
};

export const createColumnExtensionsMap = columnExtensions => {
  if (!columnExtensions || !Array.isArray(columnExtensions)) return {};

  const map = {};
  columnExtensions.forEach(ext => {
    if (ext.columnName) {
      map[ext.columnName] = ext;
    }
  });

  return map;
};
